import React, { useState, useCallback, useEffect, useMemo } from 'react';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';

import { IMissingLettersTable } from './interface';
import { IBatchRequestResponse } from 'models/Batch';
import { IMissingLettersData } from 'models/MissingLetter';

import MissingLettersServices from 'services/missingLetters.service';

import Table from '../index';
import MissingLetterSearch from './Search';

const MissingLettersTable: React.FC<IMissingLettersTable> = (props) => {
  const { model, completeBlankSpaces, refreshTable } = props;
  const [tableFilter, setTableFilter] = useState({});
  const [missingLetter, setMissingLetter] = useState<
    IBatchRequestResponse<IMissingLettersData>
  >();
  const [tableOrderBy, setTableOrderBy] = useState('id');
  const [currentPage, setCurrentPage] = useState(0);

  // eslint-disable-next-line react/destructuring-assignment
  const pageTotal = props.pageSize || 10;

  const getMissingLetters = useCallback(() => {
    const missingLettersService = new MissingLettersServices();

    setMissingLetter(undefined);

    missingLettersService
      .getByQuery(currentPage, pageTotal, tableOrderBy, { ...tableFilter })
      .then(
        (result: IBatchRequestResponse<IMissingLettersData> | undefined) => {
          if (result) {
            const { error, data, totalPages, pageSize, total } = result;
            setMissingLetter({ error, data, totalPages, pageSize, total });
          }
        }
      );
  }, [currentPage, tableFilter, tableOrderBy]);

  const MissingLettersTableRender = useMemo(
    () => (
      <Table
        trackingKey="Cartas de Falta"
        className="mt-2"
        error={missingLetter?.error}
        onReload={getMissingLetters}
        setTableOrder={setTableOrderBy}
        tableOrder={tableOrderBy}
        currentPage={currentPage}
        data={missingLetter?.data}
        pageSize={pageTotal}
        onPageChange={setCurrentPage}
        totalPages={missingLetter?.totalPages}
        model={model}
        completeBlankSpaces={completeBlankSpaces || false}
      />
    ),
    [missingLetter, model]
  );

  useEffect(() => {
    KeycloakPubServiceInstance.subscribe(() => {
      getMissingLetters();
    });
  }, [getMissingLetters, refreshTable]);

  return (
    <>
      <MissingLetterSearch
        setTableFilter={setTableFilter}
        setCurrentPage={setCurrentPage}
      />
      {MissingLettersTableRender}
    </>
  );
};

export default MissingLettersTable;
